<script setup>

import {computed, ref, watch} from "vue";
import store from "@/store";
import {getAddressBalanceAndDirectionForTransaction, processTx} from "@/utils";
import UseGEStore from "@/views/GraphExplorer/Composables/UseGEStore";
import {GERequestAction} from "@/store/modules/GraphExplorer";
import TransactionsPaginatedList from "@/components/transaction/Components/TransactionsPaginatedList.vue";
import {useGetData} from "@/components/common/Composables/useGetData";
import {DataState} from "@/components/common/types/data";
import GraphExplorerDrawerAddressSummary
    from "@/views/GraphExplorer/Components/Drawer/GraphExplorerDrawerAddressSummary.vue";

const {GESelectedElement, GETransactions} = UseGEStore()
const addressId = computed(() => GESelectedElement.value.data?.typeSpecific.address)
const transactions = ref([])

//Single source of truth for page size: the initial load and TransactionsPaginatedList
//must agree, otherwise page 1 shows this many and later pages fall back to the list default.
const ITEMS_PER_PAGE = 15

const getData = useGetData('getAddressTransactions', {
    params: {
        address: addressId.value,
        currencyUnit: "BTC"
    },
    pagination: {
        itemsPerPage: ITEMS_PER_PAGE
    }
}, false)


const loading = computed(() => getData.dataState.value === DataState.Initial || getData.dataState.value === DataState.Loading)

watch(addressId, async () => {
    if (!addressId.value)
        return

    getData.getData({
            params: {
                address: addressId.value,
                currencyUnit: "BTC"
            },
            pagination: {
                itemsPerPage: ITEMS_PER_PAGE
            }
    }, true)
}, {immediate: true})

const onCheckboxChange = (action, tx) => {
    if (action) {
        store.dispatch('GERequestAction', {
            actionType: GERequestAction.TxAddition,
            payload: {tx},
            invoker: GESelectedElement.value
        })
    } else {
        store.dispatch('GERequestAction', {
            actionType: GERequestAction.TxRemoval,
            payload: {txId: tx.txhash},
            invoker: undefined
        })
    }
}

store.dispatch('selectCurrency', {currencyUnit: 'BTC'})

</script>

<template>
    <div>
        <v-container class="px-7 mt-0 pt-1" fluid>
            <router-link
                :to="{ name: 'AddressSummary', params: {currency: 'BTC', address: addressId}}"
                class="text-h6 link"
                target="_blank"
            >
                <span class="fontMonospace">
                    {{ addressId }}
                </span>
            </router-link>
            <div class="my-2">
                <GraphExplorerDrawerAddressSummary/>
            </div>
            <div class="text-h6 my-1">
                Transactions
            </div>
            <TransactionsPaginatedList
                :get-data="getData"
                :items-per-page-default="ITEMS_PER_PAGE"
                :tx-map-function="(tx => {
                    const {balance} = getAddressBalanceAndDirectionForTransaction(addressId, tx)

                    return {
                        ...processTx(tx, addressId), currentAddressBalance: balance
                }})"
                selectable-transactions
                @selectedTransactionsChangedEvent="(event, tx) => onCheckboxChange(event, tx)"
            />
        </v-container>
    </div>
</template>

<style scoped>

</style>
